(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-v2"] && !Shopify.designMode) return;
  try {
    
  /*
    This JS is wrapped in a Custom Element to scope it
    to this section, which is Shopify best practice.
  */
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.faqItems = this.querySelectorAll(".faq-item");

        // Initialize open/closed state
        this.faqItems.forEach((item) => {
          const body = item.querySelector(".faq-body");
          if (item.classList.contains("is-open")) {
            // Allow for a default-open state (like in your example)
            body.style.maxHeight = (body.scrollHeight) + "px";
          } else {
            body.style.maxHeight = 0;
          }
        });

        // Add click listeners
        this.faqItems.forEach((item) => {
          const button = item.querySelector(".faq-header");
          button.addEventListener("click", () => {
            const isOpen = item.classList.contains("is-open");

            // Close all items (this is the one-at-a-time logic)
            this.faqItems.forEach((faq) => this.closeItem(faq));

            // If it wasn't open, open it
            if (!isOpen) {
              this.openItem(item);
            }
          });
        });
      }

      closeItem(item) {
        const button = item.querySelector(".faq-header");
        const body = item.querySelector(".faq-body");

        item.classList.remove("is-open");
        button.setAttribute("aria-expanded", "false");
        body.style.maxHeight = 0;
      }

      openItem(item) {
        const button = item.querySelector(".faq-header");
        const body = item.querySelector(".faq-body");

        item.classList.add("is-open");
        button.setAttribute("aria-expanded", "true");
        body.style.maxHeight = (body.scrollHeight + 20) + "px";
      }
    }
    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  class FaqAccordion {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.items = this.section.querySelectorAll(".accordion__item");
      this.init();
    }

    init() {
      if (this.items.length === 0) return;
      
      this.items.forEach((item) => {
        // Prevent double-binding listeners
        if (item.dataset.listenerAttached) return;
        item.dataset.listenerAttached = true;

        item.addEventListener("click", this.onItemClick.bind(this, item));
        item.addEventListener("toggle", this.onItemToggle.bind(this, item));
      });

      this.updateAccordionState();
    }

    onItemClick(clickedItem, event) {
      const isCurrentlyOpen = clickedItem.hasAttribute("open");

      if (!isCurrentlyOpen) {
        event.preventDefault();
        
        // First, apply "closing" animations
        this.updateAccordionState();

        // Use rAF to allow "closing" styles to apply before opening the new one
        requestAnimationFrame(() => {
          // Close all *other* items
          this.items.forEach((other) => {
            if (other !== clickedItem) {
              other.removeAttribute("open");
            }
          });

          // Open the clicked item
          clickedItem.setAttribute("open", "");

          // Use another rAF to apply "opening" styles
          requestAnimationFrame(() => {
            this.updateAccordionState();
          });
        });
      }
    }

    onItemToggle(toggledItem) {
      // This catches when an item is closed (e.g., clicking it again)
      if (!toggledItem.open) {
        this.updateAccordionState();
      }
    }

    updateAccordionState() {
      // Re-query items *inside* the function to get the most current DOM state
      const currentItems = this.section.querySelectorAll(".accordion__item");
      const openItem = this.section.querySelector(".accordion__item[open]");

      currentItems.forEach((item) => {
        item.classList.remove(
          "accordion__item--open",
          "accordion__item--before-open",
          "accordion__item--after-open",
          "accordion__item--dimmed"
        );

        if (openItem) {
          if (item === openItem) {
            item.classList.add("accordion__item--open");
          } else {
            item.classList.add("accordion__item--dimmed");

            const itemsArray = Array.from(currentItems);
            const currentIndex = itemsArray.indexOf(item);
            const openIndex = itemsArray.indexOf(openItem);

            if (currentIndex < openIndex) {
              item.classList.add("accordion__item--before-open");
            } else {
              item.classList.add("accordion__item--after-open");
            }
          }
        }
      });
    }
  }

  // --- Shopify Theme Editor Integration ---

  const initFaqSection = (sectionElement) => {
    if (!sectionElement) return;
    // Store instance on the element to prevent re-initialization
    if (!sectionElement.faqAccordionInstance) {
      sectionElement.faqAccordionInstance = new FaqAccordion(sectionElement);
    }
  };

  const reInitFaqSection = (sectionElement) => {
    if (!sectionElement) return;
    // Create a new instance to pick up DOM changes (add/remove block)
    sectionElement.faqAccordionInstance = new FaqAccordion(sectionElement);
  };
  
  // Initial load for storefront
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-accordion-section').forEach(section => {
      initFaqSection(section);
    });
  });

  // Shopify Theme Editor specific listeners
  if (window.Shopify && Shopify.designMode) {
    // Section is added to the page
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('faq-accordion-section')) {
        initFaqSection(event.target);
      }
    });

    // Blocks are added, removed, or reordered
    const reInitHandler = (event) => {
      const section = event.target.closest('.faq-accordion-section');
      if (section) {
        reInitFaqSection(section);
      }
    };
    
    document.addEventListener('shopify:block:add', reInitHandler);
    document.addEventListener('shopify:block:remove', reInitHandler);
    document.addEventListener('shopify:section:reorder', reInitHandler);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-intro"] && !Shopify.designMode) return;
  try {
    
  function setupFounderTimeline(container) {
    if (typeof jQuery === 'undefined') {
      setTimeout(() => setupFounderTimeline(container), 50);
      return;
    }

    const $ = jQuery;
    // Find the timeline within this specific section container
    var timelines = $(container).find('.cd-horizontal-timeline'),
      eventsMinDistance = 60;

    if (timelines.length === 0) return;

    // --- Helper Functions from user's code ---

    function updateSlide(timelineComponents, timelineTotWidth, string) {
      //retrieve translateX value of timelineComponents['eventsWrapper']
      var translateValue = getTranslateValue(timelineComponents['eventsWrapper']),
        wrapperWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', ''));
      //translate the timeline to the left('next')/right('prev') 
      (string == 'next') 
        ? translateTimeline(timelineComponents, translateValue - wrapperWidth + eventsMinDistance, wrapperWidth - timelineTotWidth)
        : translateTimeline(timelineComponents, translateValue + wrapperWidth - eventsMinDistance);
    }

    function showNewContent(timelineComponents, timelineTotWidth, string) {
      //go from one event to the next/previous one
      var visibleContent =  timelineComponents['eventsContent'].find('.selected'),
        newContent = ( string == 'next' ) ? visibleContent.next() : visibleContent.prev();

      if ( newContent.length > 0 ) { //if there's a next/prev event - show it
        var selectedDate = timelineComponents['eventsWrapper'].find('.selected'),
          newEvent = ( string == 'next' ) ? selectedDate.parent('li').next('li').children('a') : selectedDate.parent('li').prev('li').children('a');
        
        updateFilling(newEvent, timelineComponents['fillingLine'], timelineTotWidth);
        updateVisibleContent(newEvent, timelineComponents['eventsContent']);
        newEvent.addClass('selected');
        selectedDate.removeClass('selected');
        updateOlderEvents(newEvent);
        updateTimelinePosition(string, newEvent, timelineComponents, timelineTotWidth);
      }
    }

    function updateTimelinePosition(string, event, timelineComponents, timelineTotWidth) {
      //translate timeline to the left/right according to the position of the selected event
      var eventStyle = window.getComputedStyle(event.get(0), null),
        eventLeft = Number(eventStyle.getPropertyValue("left").replace('px', '')),
        timelineWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', '')),
        timelineTotWidth = Number(timelineComponents['eventsWrapper'].css('width').replace('px', ''));
      var timelineTranslate = getTranslateValue(timelineComponents['eventsWrapper']);

        if( (string == 'next' && eventLeft > timelineWidth - timelineTranslate) || (string == 'prev' && eventLeft < - timelineTranslate) ) {
          translateTimeline(timelineComponents, - eventLeft + timelineWidth/2, timelineWidth - timelineTotWidth);
        }
    }

    function translateTimeline(timelineComponents, value, totWidth) {
      var eventsWrapper = timelineComponents['eventsWrapper'].get(0);
      value = (value > 0) ? 0 : value; //only negative translate value
      value = ( !(typeof totWidth === 'undefined') &&  value < totWidth ) ? totWidth : value; //do not translate more than timeline width
      setTransformValue(eventsWrapper, 'translateX', value+'px');
      //update navigation arrows visibility
      (value == 0 ) ? timelineComponents['timelineNavigation'].find('.prev').addClass('inactive') : timelineComponents['timelineNavigation'].find('.prev').removeClass('inactive');
      (value == totWidth ) ? timelineComponents['timelineNavigation'].find('.next').addClass('inactive') : timelineComponents['timelineNavigation'].find('.next').removeClass('inactive');
    }

    function updateFilling(selectedEvent, filling, totWidth) {
      //change .filling-line length according to the selected event
      var eventStyle = window.getComputedStyle(selectedEvent.get(0), null),
        eventLeft = eventStyle.getPropertyValue("left"),
        eventWidth = eventStyle.getPropertyValue("width");
      eventLeft = Number(eventLeft.replace('px', '')) + Number(eventWidth.replace('px', ''))/2;
      var scaleValue = eventLeft/totWidth;
      setTransformValue(filling.get(0), 'scaleX', scaleValue);
    }

    function setDatePosition(timelineComponents, min) {
      if (timelineComponents['timelineDates'].length === 0) return;
      for (var i = 0; i < timelineComponents['timelineDates'].length; i++) { 
        var distance = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][i]),
          distanceNorm = Math.round(distance/timelineComponents['eventsMinLapse']) + 2;
        timelineComponents['timelineEvents'].eq(i).css('left', distanceNorm*min+'px');
      }
    }

    function setTimelineWidth(timelineComponents, width) {
      if (timelineComponents['timelineDates'].length === 0) return 0;
      var timeSpan = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][timelineComponents['timelineDates'].length-1]),
        timeSpanNorm = timeSpan/timelineComponents['eventsMinLapse'],
        timeSpanNorm = Math.round(timeSpanNorm) + 4,
        totalWidth = timeSpanNorm*width;
      timelineComponents['eventsWrapper'].css('width', totalWidth+'px');
      updateFilling(timelineComponents['timelineEvents'].eq(0), timelineComponents['fillingLine'], totalWidth);
    
      return totalWidth;
    }

    function updateVisibleContent(event, eventsContent) {
      var eventDate = event.data('date'),
        visibleContent = eventsContent.find('.selected'),
        selectedContent = eventsContent.find('[data-date="'+ eventDate +'"]'),
        selectedContentHeight = selectedContent.height();

      if (selectedContent.index() > visibleContent.index()) {
        var classEnetering = 'selected enter-right',
          classLeaving = 'leave-left';
      } else {
        var classEnetering = 'selected enter-left',
          classLeaving = 'leave-right';
      }

      selectedContent.attr('class', classEnetering);
      visibleContent.attr('class', classLeaving).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
        visibleContent.removeClass('leave-right leave-left');
        selectedContent.removeClass('enter-left enter-right');
      });
      eventsContent.css('height', selectedContentHeight+'px');
    }

    function updateOlderEvents(event) {
      event.parent('li').prevAll('li').children('a').addClass('older-event').end().end().nextAll('li').children('a').removeClass('older-event');
    }

    function getTranslateValue(timeline) {
      var timelineStyle = window.getComputedStyle(timeline.get(0), null),
        timelineTranslate = timelineStyle.getPropertyValue("-webkit-transform") ||
                  timelineStyle.getPropertyValue("-moz-transform") ||
                  timelineStyle.getPropertyValue("-ms-transform") ||
                  timelineStyle.getPropertyValue("-o-transform") ||
                  timelineStyle.getPropertyValue("transform");

        if( timelineTranslate.indexOf('(') >=0 ) {
          var timelineTranslate = timelineTranslate.split('(')[1];
        timelineTranslate = timelineTranslate.split(')')[0];
        timelineTranslate = timelineTranslate.split(',');
        var translateValue = timelineTranslate[4];
        } else {
          var translateValue = 0;
        }

        return Number(translateValue);
    }

    function setTransformValue(element, property, value) {
      element.style["-webkit-transform"] = property+"("+value+")";
      element.style["-moz-transform"] = property+"("+value+")";
      element.style["-ms-transform"] = property+"("+value+")";
      element.style["-o-transform"] = property+"("+value+")";
      element.style["transform"] = property+"("+value+")";
    }

    function parseDate(events) {
      var dateArrays = [];
      events.each(function(){
        var dateComp = $(this).data('date').split('/'),
          newDate = new Date(dateComp[2], dateComp[1]-1, dateComp[0]);
        dateArrays.push(newDate);
      });
        return dateArrays;
    }

    function daydiff(first, second) {
      return Math.round((second-first));
    }

    function minLapse(dates) {
      //determine the minimum distance among events
      var dateDistances = [];
      for (var i = 1; i < dates.length; i++) { 
        var distance = daydiff(dates[i-1], dates[i]);
        dateDistances.push(distance);
      }
      return Math.min.apply(null, dateDistances);
    }

    function elementInViewport(el) {
      var top = el.offsetTop;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight;

      while(el.offsetParent) {
          el = el.offsetParent;
          top += el.offsetTop;
          left += el.offsetLeft;
      }

      return (
          top < (window.pageYOffset + window.innerHeight) &&
          left < (window.pageXOffset + window.innerWidth) &&
          (top + height) > window.pageYOffset &&
          (left + width) > window.pageXOffset
      );
    }

    function checkMQ() {
      //check if mobile or desktop device
      // Scoped to the container
      return window.getComputedStyle(container.querySelector('.cd-horizontal-timeline'), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "");
    }

    // --- Main Init Function ---

    function initTimeline(timelines) {
      timelines.each(function(){
        var timeline = $(this),
          timelineComponents = {};
        //cache timeline components 
        timelineComponents['timelineWrapper'] = timeline.find('.events-wrapper');
        timelineComponents['eventsWrapper'] = timelineComponents['timelineWrapper'].children('.events');
        timelineComponents['fillingLine'] = timelineComponents['eventsWrapper'].children('.filling-line');
        timelineComponents['timelineEvents'] = timelineComponents['eventsWrapper'].find('a');
        timelineComponents['timelineDates'] = parseDate(timelineComponents['timelineEvents']);
        
        if (timelineComponents['timelineDates'].length === 0) return; // Exit if no slides

        timelineComponents['eventsMinLapse'] = minLapse(timelineComponents['timelineDates']);
        
        if (!isFinite(timelineComponents['eventsMinLapse'])) { // Fix for single slide
            timelineComponents['eventsMinLapse'] = 1; 
        }

        timelineComponents['timelineNavigation'] = timeline.find('.cd-timeline-navigation');
        timelineComponents['eventsContent'] = timeline.children('.events-content');

        //assign a left postion to the single events along the timeline
        setDatePosition(timelineComponents, eventsMinDistance);
        //assign a width to the timeline
        var timelineTotWidth = setTimelineWidth(timelineComponents, eventsMinDistance);
        //the timeline has been initialize - show it
        timeline.addClass('loaded');

        //detect click on the next arrow
        timelineComponents['timelineNavigation'].on('click', '.next', function(event){
          event.preventDefault();
          updateSlide(timelineComponents, timelineTotWidth, 'next');
        });
        //detect click on the prev arrow
        timelineComponents['timelineNavigation'].on('click', '.prev', function(event){
          event.preventDefault();
          updateSlide(timelineComponents, timelineTotWidth, 'prev');
        });
        //detect click on the a single event - show new event content
        timelineComponents['eventsWrapper'].on('click', 'a', function(event){
          event.preventDefault();
          timelineComponents['timelineEvents'].removeClass('selected');
          $(this).addClass('selected');
          updateOlderEvents($(this));
          updateFilling($(this), timelineComponents['fillingLine'], timelineTotWidth);
          updateVisibleContent($(this), timelineComponents['eventsContent']);
          updateCarouselNavButtons(); // Update carousel nav buttons
        });

        // --- NEW: Carousel Navigation Buttons ---
        // Find the carousel navigation buttons
        var $prevBtn = $(container).find('.carousel-nav-btn--prev');
        var $nextBtn = $(container).find('.carousel-nav-btn--next');

        // Update button states based on current slide
        function updateCarouselNavButtons() {
          var visibleContent = timelineComponents['eventsContent'].find('.selected');
          var isFirst = visibleContent.prev().length === 0;
          var isLast = visibleContent.next().length === 0;
          
          $prevBtn.toggleClass('inactive', isFirst);
          $nextBtn.toggleClass('inactive', isLast);
        }

        // Initial button state
        updateCarouselNavButtons();

        // Handle prev button click
        $prevBtn.on('click', function(event) {
          event.preventDefault();
          if (!$(this).hasClass('inactive')) {
            showNewContent(timelineComponents, timelineTotWidth, 'prev');
            updateCarouselNavButtons();
          }
        });

        // Handle next button click
        $nextBtn.on('click', function(event) {
          event.preventDefault();
          if (!$(this).hasClass('inactive')) {
            showNewContent(timelineComponents, timelineTotWidth, 'next');
            updateCarouselNavButtons();
          }
        });
        // --- END: Carousel Navigation Buttons ---

        // --- JAVASCRIPT UPDATED ---
        //on swipe, show next/prev event content
        // Note: This requires a jQuery swipe library (like jQuery touchSwipe) to be loaded in your theme.
        timelineComponents['eventsContent'].on('swipeleft', function(){
          var mq = checkMQ();
          if ( mq == 'mobile' ) {
            showNewContent(timelineComponents, timelineTotWidth, 'next');
            updateCarouselNavButtons();
          }
        });
        timelineComponents['eventsContent'].on('swiperight', function(){
          var mq = checkMQ();
          if ( mq == 'mobile' ) {
            showNewContent(timelineComponents, timelineTotWidth, 'prev');
            updateCarouselNavButtons();
          }
        });
        // --- END JAVASCRIPT UPDATE ---
        
        //keyboard navigation
        $(document).keyup(function(event){
          if(event.which=='37' && elementInViewport(timeline.get(0)) ) {
            showNewContent(timelineComponents, timelineTotWidth, 'prev');
            updateCarouselNavButtons();
          } else if( event.which=='39' && elementInViewport(timeline.get(0))) {
            showNewContent(timelineComponents, timelineTotWidth, 'next');
            updateCarouselNavButtons();
          }
        });

        // Set initial height of content area
        var initialContent = timelineComponents['eventsContent'].find('.selected');
        if (initialContent.length > 0) {
            timelineComponents['eventsContent'].css('height', initialContent.height() + 'px');
        }

        // --- VIDEO AUTO-PLAY/PAUSE FUNCTIONALITY ---
        // Setup Intersection Observer for auto-play/pause
        function setupVideoAutoPlay() {
          const videos = $(container).find('[data-video-element]');
          
          if (videos.length === 0) return;

          // Create intersection observer for each video
          videos.each(function() {
            const video = this;
            const $slideContent = $(video).closest('li');
            
            // Observer to detect when slide is visible
            const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting && $slideContent.hasClass('selected')) {
                  // Video is in view and slide is selected - play it
                  video.play().catch(err => console.log('Video play failed:', err));
                } else {
                  // Video is out of view or slide not selected - pause it
                  video.pause();
                }
              });
            }, {
              threshold: 0.5 // Play when 50% visible
            });

            observer.observe(video);
          });

          // Also handle video play/pause when slides change
          timelineComponents['eventsContent'].on('DOMSubtreeModified', function() {
            const selectedSlide = $(this).find('li.selected');
            const selectedVideo = selectedSlide.find('[data-video-element]')[0];
            
            // Pause all videos first
            videos.each(function() {
              this.pause();
            });

            // Play the video in the selected slide
            if (selectedVideo) {
              selectedVideo.play().catch(err => console.log('Video play failed:', err));
            }
          });
        }

        // Setup mute/unmute buttons
        function setupMuteButtons() {
          const muteButtons = $(container).find('[data-mute-btn]');
          
          muteButtons.each(function() {
            const $btn = $(this);
            const $video = $btn.siblings('[data-video-element]')[0];
            
            if (!$video) return;

            $btn.on('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              const $mutedIcon = $btn.find('.video-mute-btn__icon--muted');
              const $unmutedIcon = $btn.find('.video-mute-btn__icon--unmuted');
              
              if ($video.muted) {
                $video.muted = false;
                $mutedIcon.hide();
                $unmutedIcon.show();
              } else {
                $video.muted = true;
                $mutedIcon.show();
                $unmutedIcon.hide();
              }
            });
          });
        }

        // Initialize video features
        setupVideoAutoPlay();
        setupMuteButtons();
        // --- END VIDEO FUNCTIONALITY ---
      });
    }

    // Start the timeline
    (timelines.length > 0) && initTimeline(timelines);
  }

  // Handle Shopify Theme Editor loads/reloads
  document.addEventListener('shopify:section:load', (event) => {
    const sectionContainer = event.target.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
    // Check if the loaded section is this one
    if (sectionContainer && sectionContainer.classList.contains('founder-intro-container')) {
      setupFounderTimeline(sectionContainer);
    }
  });

  // Handle initial page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.founder-intro-container').forEach((container) => {
      setupFounderTimeline(container);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
